module.exports = __webpack_public_path__ + "img/142_thumbnail.b2a1e9fa.jpg";